<template>
  <div>
    <ul class="tree">
      <tree-node :item="treeNodes" :open-default="true" :toggle-handler="toggle" :select-handler="select" />
    </ul>

    <div id="file-explorer-context-menu" />
  </div>
</template>

<script>
import { isEmpty, compact } from 'lodash-es'
import { mapGetters } from 'vuex'
import eventBus from '@/modules/eventBus'

import TreeNode from './TreeNode'

export default {
  components: { TreeNode },

  props: {
    gateway: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters(['treeNodes']),

    // Explode current directory into array
    directoryList () {
      if (!isEmpty(this.currentDirectory)) {
        return ['/', ...compact(this.currentDirectory.split('/'))]
      } else {
        return ['/']
      }
    }
  },

  watch: {
    gateway (newGw, oldGw) {
      // Get tree node content only when loading gateway the first time
      if (isEmpty(oldGw) && !isEmpty(this.gateway)) {
        this.getDirectory(this.treeNodes)
      }
    }
  },

  created () {
    if (!isEmpty(this.gateway)) {
      this.getDirectory(this.treeNodes)
    }
  },

  methods: {
    // Get a specific directory
    async getDirectory (parentNode, changeCurrentDirectory = true) {
      // Send naviagtion event
      eventBus.$emit('fileExplorer:navigate')

      // Use nextTick to let the cancelNewFolder finish
      await this.$nextTick()
      return this.$store.dispatch('getDirectory', {
        directory: parentNode.path,
        parentNode,
        changeCurrentDirectory
      })
    },

    // When openning/closing a node
    toggle (treeNode) {
      this.getDirectory(treeNode, false)
    },

    // When selecting/deselecting a node
    select (treeNode) {
      // Get directory content if selected
      this.getDirectory(treeNode)
    }
  }
}
</script>

<style scoped lang="scss">
  @import "~@/scss/variables";

  .tree {
    padding: 5px;
    margin: 0;
    list-style: none;
  }
</style>
